/* eslint-disable import/no-named-as-default */
/* eslint-disable no-shadow */
import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import {
  loadingSubscriptionPlans,
  toggleTermsModal,
  loadAnnualSubscriptionPlans,
} from "../../actions/subscriptionPlansActions";
import FullScreenLoading from "../shared/loaders/FullScreenLoading";
import AnnualPlansList from "./AnnualPlansList";
import planType from "./types/planType";

export class Annually extends Component {
  componentDidMount() {
    const { loadAnnualSubscriptionPlans, loadingSubscriptionPlans } =
      this.props;
    loadingSubscriptionPlans();
    loadAnnualSubscriptionPlans();
  }

  render() {
    const { loading, annually, termsAnnually, toggleTermsModal } = this.props;
    return (
      <Fragment>
        {loading ? (
          <FullScreenLoading />
        ) : (
          <AnnualPlansList
            annually={annually || []}
            termsAnnually={termsAnnually}
            toggleTermsModal={toggleTermsModal}
          />
        )}
      </Fragment>
    );
  }
}

Annually.propTypes = {
  annually: PropTypes.arrayOf(planType),
  loading: PropTypes.bool.isRequired,
  loadingSubscriptionPlans: PropTypes.func.isRequired,
  loadAnnualSubscriptionPlans: PropTypes.func.isRequired,
  termsAnnually: PropTypes.string,
  toggleTermsModal: PropTypes.func.isRequired,
};

Annually.defaultProps = {
  annually: PropTypes.isNull,
  termsAnnually: PropTypes.isNull,
};

const mapStateToProps = (state) => ({
  annually: state.subscriptionPlans.annually,
  loading: state.subscriptionPlans.loading,
  termsAnnually: state.subscriptionPlans.termsAnnually,
});

export default connect(mapStateToProps, {
  toggleTermsModal,
  loadingSubscriptionPlans,
  loadAnnualSubscriptionPlans,
})(Annually);
